<template>
    <div>
        <div class="section-subtitle-wrapper">
            <h3>{{t('contact_popup.call_sessions.title')}}</h3>
        </div>
        <table class="simple-report">
            <thead>
            <tr>
                <th>{{t('contact_popup.call_sessions.type')}}</th>
                <th>{{t('contact_popup.call_sessions.date')}}</th>
                <th>{{t('contact_popup.call_sessions.time')}}</th>
                <th>{{t('contact_popup.call_sessions.campaign')}}</th>
                <th>{{t('contact_popup.call_sessions.user')}}</th>
                <th>{{t('contact_popup.call_sessions.action')}}</th>
                <th>{{t('contact_popup.call_sessions.reason')}}</th>
                <th>{{t('contact_popup.call_sessions.comment')}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="call in callSessions" @click="showCallHistory(call.id)">
                <td>{{t('call_types')[call.type]}}</td>
                <td>{{call.date}}</td>
                <td>{{call.time}}</td>
                <td>{{call.campaign_name}}</td>
                <td>{{call.user}}</td>
                <td>{{t('call_actions')[call.action]}}</td>
                <td>{{call.reason}}</td>
                <td>{{call.comment}}</td>
            </tr>

            </tbody>
        </table>

        <div class="history-area" v-if="selectedCallSessionId">

            <div class="section-subtitle-wrapper">
                <h3>{{t('contact_popup.call_history.title')}}</h3>
            </div>

            <table class="simple-report">
                <thead>
                <tr>
                    <th>{{t('call_history_report.columns.phone')}}</th>
                    <th>{{t('call_history_report.columns.net_duration')}}</th>
                    <th>{{t('call_history_report.columns.status')}}</th>
                    <th>{{t('call_history_report.columns.start_time')}}</th>
                    <th>{{t('call_history_report.columns.play_record')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(call, i) in callHistory">
                    <td>{{call.phone}}</td>
                    <td>{{call.net_duration}}</td>
                    <td>{{call.status}}</td>
                    <td>{{call.start_time}}</td>
                    <td>
                        <div class="row-player" :class="playerRowClass(call.ami_uniqueid)">

                            <button class="play-pause" @click="playPause(call.ami_uniqueid)"></button>
                            <button class="stop" @click="player.stop = true"></button>
                            <button class="download" @click="download(i)"></button>

                            <a :href="streamUrl(call.ami_uniqueid)"
                               :download="call.ami_uniqueid + '.mp3'"
                               :ref="`download_link`"
                               v-show="false"
                            >download</a>

                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <player-bar
                    v-show="!player.stop && player.playUniqueId"
                    v-bind="player"
                    v-on:change="player.play = $event"
            ></player-bar>
        </div>
    </div>
</template>

<script>
    import i18n, { t } from '../i18n/i18n.js';
    import app from '../App';
    import LoadingPopupView from '../../controls/LoadingPopupView';
    import TimeFormatters from '../../appHelpers/TimeFormatters';
    import PlayerBar from '../views/PlayerBar.vue';

    export default {
        components: {PlayerBar},
        props: ['contactId'],
        data() {
            return {
                loader: new LoadingPopupView(t('activity_indicator.loading')),
                callSessions: [],
                callHistory: [],
                selectedCallSessionId: null,
                player: {
                    play: false,
                    stop: false,
                    playUniqueId: null,
                },
                streamUrl(uniqueId) {
                    return app.apiUrl('recordings/stream', { 'uniqueid': uniqueId }, false);
                }
            }
        },
        mounted() {
            this.getCallSessions()
        },
        watch: {
            'player.play': function (value) {
                if (!value) return;
                this.player.stop = false;
            },
            selectedCallSessionId() {
                this.player.play = false;
                this.player.playUniqueId = null;
            }
        },
        methods: {
            getCallSessions() {

                const fields =
                    ['id', 'continue_reason_id', 'continue_reason_name',
                        'end_reason_id', 'end_reason_name', 'campaign_name',
                        'type',
                        'user_first_name', 'user_last_name',
                        'start_time', 'comment'].join(',');

                const params = {'contact_id': this.contactId, 'fields': fields};

                setTimeout(() => { // Do after rendering to screen

                    this.loader.show(this.$el);

                    this.ajaxGet(app.apiUrl('call_sessions', params))
                        .always(() => this.loader.hide())
                        .then(calls => this.callSessions = calls.map(call => {

                            const {id, campaign_name, comment, end_reason_id, continue_reason_id,
                                continue_reason_name, end_reason_name, start_time, type,
                                user_first_name, user_last_name} = call;
                            const date = new Date(start_time);
                            const action = continue_reason_id ? 'continue' : end_reason_id ? 'end' : '';

                            return {
                                id, campaign_name, comment, action, type,
                                date: i18n.formatDate(date, t('date_formats.normal_date')),
                                time: i18n.formatDate(date, t('date_formats.short_time')),
                                user: `${user_first_name || ''} ${user_last_name || ''}`.trim(),
                                reason: (action === 'continue' ? continue_reason_name : end_reason_name) || ''
                            }
                        }))
                        .fail(app.showXhrError);

                }, 0)

            },

            showCallHistory(callSessionId) {

                this.selectedCallSessionId = callSessionId;

                const fields = [
                    'id',
                    'start_time',
                    'status',
                    'phone',
                    'answered_on',
                    'disconnected_on',
                    'ami_uniqueid',
                    'gross_duration',
                    'net_duration'
                ].join(',');

                this.loader.show(this.$el);

                this.ajaxGet(app.apiUrl('call_history'), { 'fields': fields, 'filters': JSON.stringify( { 'call_session_id': { 'mode':'=', 'value': callSessionId } } ) })
                    .always(() => this.loader.hide())
                    .then(calls => this.callHistory = calls.map(call => {

                        const {id, start_time, status, phone, net_duration, ami_uniqueid} = call;

                        return {
                            phone: PhoneNumberUtil.displayPhoneNumber(phone || ''),
                            net_duration: TimeFormatters.timeFromSeconds(net_duration),
                            status: t('call_history_statuses')[status],
                            start_time: start_time ? i18n.formatDate(new Date(start_time), t('date_formats.short_time')) : '',
                            ami_uniqueid
                        }

                    }))
                    .fail(app.showXhrError);

            },

            playPause(uniqueId) {

                if (this.player.play && this.player.playUniqueId === uniqueId) {
                    return this.player.play = false;
                }
                if (this.player.playUniqueId !== uniqueId) {
                    return this.player.playUniqueId = uniqueId;
                }
                this.player.play = true;
            },

            playerRowClass(uniqueId) {
                if (this.player.playUniqueId !== uniqueId || this.player.stop) {
                    return 'stopped';
                }
                if (this.player.play) {
                    return 'playing';
                } else {
                    return 'paused';
                }

            },

            download(i) {
                this.$refs.download_link[i].click();
            },
        },
        beforeDestroy() {
            this.loader.remove();
        },
    }
</script>